import { useContext } from 'react';
import { Button } from '../core/button';
import styles from './demo-switch.module.scss';
import { SalesContext } from '../../SalesContext';

export default function DemoSwitch() {
  const { isDemo, setDemo } = useContext(SalesContext);

  return (
    <div className={styles.buttonContainer}>
      <Button
        onClick={() => setDemo(!isDemo)}
        className={styles.button}
        title="Sätt på eller stäng av demoläge">
        Demoläge {isDemo ? "på" : "av"}
      </Button>
    </div>
  )
}